import DashboardControls, { DashboardControlsProps } from './Controls'

interface DashboardPageProps<TabId> extends DashboardControlsProps<TabId> {
  headerComp: React.ReactNode
  children: React.ReactNode
}

export default function DashboardPage<TabId>({
  headerComp,
  tabs,
  current,
  viewSetting,
  setViewSetting,
  hideViewToggle,
  children
}: DashboardPageProps<TabId>) {
  return (
    <div className="bg-gray-50 flex-1 flex flex-col dark:bg-gray-950/40">
      <header className="bg-white dark:bg-gray-900">{headerComp}</header>
      <div className="bg-white dark:bg-gray-900">
        <DashboardControls<TabId>
          tabs={tabs}
          current={current}
          viewSetting={viewSetting}
          setViewSetting={setViewSetting}
          hideViewToggle={hideViewToggle}
        />
      </div>
      {children}
    </div>
  )
}
